import React, { useMemo, useState } from "react";
import PageHero from "../components/shared/PageHero";
import CategoryPills from "../components/shared/CategoryPills";
import ProductGrid from "../components/shop/ProductGrid";
import Newsletter from "../components/Newsletter";
import { products, productCategories } from "../productsData";

export default function Shop() {
  const [activeCategory, setActiveCategory] = useState("All");

  const filtered = useMemo(() => {
    if (activeCategory === "All") return products;
    return products.filter((p) => p.category === activeCategory);
  }, [activeCategory]);

  return (
    <>
      <PageHero
        eyebrow="Official Merchandise"
        title="Wear the Culture"
        subtitle="Support your favorite artists with exclusive apparel, accessories, and limited-edition collectibles."
      />

      <section className="mu-section pb-0">
        <div className="container">
          <CategoryPills categories={productCategories} active={activeCategory} onSelect={setActiveCategory} />
          <div className="track-meta mt-3">{filtered.length} Products</div>
        </div>
      </section>

      <ProductGrid products={filtered} />
      <Newsletter />
    </>
  );
}
